import { Component, Inject, OnInit } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminCancelTripComponent } from "../admin-cancel-trip/admin-cancel-trip.component";
import { AdminCancelQuoteComponent } from '../admin-cancel-quote/admin-cancel-quote.component';
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-trips-view",
  templateUrl: "./admin-trips-view.component.html",
  styleUrls: ["./admin-trips-view.component.css"],
})
export class AdminTripsViewComponent implements OnInit {
  matDialogref!: MatDialogRef<AdminCancelTripComponent>;
  matDialogRefCancelQuote!: MatDialogRef<AdminCancelQuoteComponent>;
  tripsData: any = [];
  taxData: any;
  tax: any;
  totalTax: any;
  price: any;
  taxDetails: any;
  NotesData: any;
  paymentArray: any;
  cancel_button: boolean = false;
  totalTaxAmount: number = 0;
  transTaxAmount: number = 0;
  searchTaxType: any = "driver";
  searchTaxCustomer: any = "customer";
  token: any;
  tripType: any = -1;
  perPage: any = 100;
  page: any = 1;
  downloadingLRIndex: number | null = null;
  taxArray: any = [];
  document_array: any = [];
  driverArray: any = [];
  customerArray: any = [];
  trip_history: any = [];
  constructor(
    private matdialogref: MatDialogRef<AdminTripsViewComponent>,
    private matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private services: AdminService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {
    this.tripsData = this.data;
  }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.getTax();
    this.getTaxCustomer();
    if (this.tripsData.paymentInfo[0]?.payment_id) {
      this.paymentInfo();
    }

    this.trip_history = this.getLatestEntries(
      this.tripsData?.trip_history
    ).filter(
      (history) =>
        history?.is_verified !== 0
    );

    this.GetNotes();
  }

  DownloadLR(item: any, i: number) {
    if (this.downloadingLRIndex === i) {
      return; // prevent duplicate click
    }
    this.downloadingLRIndex = i;
    const trip_no = item?.trip_id;
    const elr_no = item.elr_details[i].elr_no;
    const trip_id = item?._id;
    const elr_id = item.elr_details[i]._id;
    this.services.downloadELR(this.token, trip_id, elr_id).subscribe(
      (res: any) => {
        const blob = res.body;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `eLR_${trip_no}_${elr_no}.pdf`;
        a.click();
        URL.revokeObjectURL(url);
        this.downloadingLRIndex = null; // stop loader
      },
      (err) => {
        console.error("ELR download error:", err);
        this.downloadingLRIndex = null; // stop loader on error
      }
    );
  }

  private getLatestEntries(data: any[]): any[] {
    const latestEntries = new Map<string, any>();

    data.forEach((item) => {
      const existing = latestEntries.get(item.name);
      if (!existing || new Date(item.date) > new Date(existing.date)) {
        latestEntries.set(item.name, item);
      }
    });

    return Array.from(latestEntries.values());
  }

  getTax() {
    this.services
      .TaxGet(
        this.token,
        this.searchTaxType,
        this.tripType,
        this.perPage,
        this.page
      )
      .subscribe((response: any) => {
        this.taxArray = response.body.data.data;
        this.document_array.push(response.body.meta);

        this.driverArray = this.taxArray.filter(
          (tax: any) => tax.tax_user_type === "driver"
        );
        this.calculateTax();
      });
  }

  getTaxCustomer() {
    this.services
      .TaxGet(
        this.token,
        this.searchTaxCustomer,
        this.tripType,
        this.perPage,
        this.page
      )
      .subscribe((response: any) => {
        this.taxArray = response.body.data.data;
        this.document_array.push(response.body.meta);

        this.customerArray = this.taxArray.filter(
          (tax: any) => tax.tax_user_type === "customer"
        );

        this.calculateTax();
        this.paymentInfo();
      });
  }

  calculateTax() {
    this.taxDetails = this.tripsData.paymentInfo[0]?.price_details?.tax_details;

    this.taxData =
      (this.tripsData.paymentInfo[0]?.price_details?.actual_price || 0) *
      (this.tripsData.paymentInfo[0]?.price_details?.tax_details?.[0]
        ?.tax_deduction || 0);

    const actualPrice =
      this.tripsData.paymentInfo[0]?.price_details?.actual_price || 0;

    const transPrice =
      this.tripsData.paymentInfo[0]?.price_details?.actual_price || 0;

    const taxDetails = this.tripsData.paymentInfo[0]?.price_details?.tax_details;

    const trans_actual_price =
      this.tripsData.paymentInfo[0]?.price_details?.transporter_tax_details || [];

    this.totalTaxAmount = taxDetails?.reduce((total: number, tax: any) => {
      const taxDeduction = parseFloat(tax.tax_deduction) || 0;
      if (tax.tax_type === 'percent') {
        return total + (actualPrice * taxDeduction) / 100;
      } else {
        return total + taxDeduction;
      }
    }, 0) || 0;

    this.transTaxAmount = trans_actual_price.reduce((total: any, tax: any) => {
      const taxDeduction = parseFloat(tax.tax_deduction) || 0;
      if (tax.tax_type === "amount") {
        return total + taxDeduction;
      } else if (tax.tax_type === "percent") {
        return total + (transPrice * taxDeduction) / 100;
      }
      return total;
    }, 0) || 0;

    this.tax =
      (this.taxData / 100) +
      (this.tripsData.paymentInfo[0]?.price_details?.actual_price || 0);

    this.totalTax = Math.round(this.taxData);
    if (
      this.tripsData.trip_status === "tripbooked" &&
      this.tripsData?.userInfo[0]?.user_type != "corporate"
    ) {
      this.cancel_button = true;
    }
  }

  paymentInfo() {
    this.paymentArray =
      this.tripsData.paymentInfo?.[0]?.price_details?.payment_history || [];
  }

  close() {
    this.matdialogref.close();
  }

  cancelTrip(item: any) {
    this.matDialogref = this.matDialog.open(AdminCancelTripComponent, {
      width: "40vw",
      autoFocus: false,
      data: item,
    });
    this.matDialogref.afterClosed().subscribe((x) => {
      this.paymentInfo();
    });
  }

  cancelQuote(item: any) {
    this.matDialogRefCancelQuote = this.matDialog.open(AdminCancelQuoteComponent, {
      data: item,
      autoFocus: false,
    });
    this.matDialogRefCancelQuote.afterClosed().subscribe((res) => {
    });
  }

  cancelQuoteBooked(item: any) {
    this.matDialogRefCancelQuote = this.matDialog.open(AdminCancelQuoteComponent, {
      data: item,
      autoFocus: false,
    });
    this.matDialogRefCancelQuote.afterClosed().subscribe((res) => {
    });
  }

  consignment(item: any) {
    window.open(item.consignment_details.consignment_url, "_blank");
  }

  public GetNotes() {
    let token = localStorage.getItem("adminToken");
    this.services.GetNotes(this.data._id, token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.NotesData = response.body.data.filter(
            (item: any) => item.module_type === "trip"
          );
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          this.matDialogref.close();
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          this.matDialogref.close();
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          this.matDialogref.close();
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  isGeneratingELR: boolean = false;

  generateELR(tripsData: any) {
    this.isGeneratingELR = true;
    const tripId = tripsData?._id;
    this.services.generateELR(tripId, this.token).subscribe(
      (response: any) => {
        console.log('eLR generated:', response.body);
        if (response.body?.data?.elr_details) {
          this.tripsData.elr_details = response.body.data.elr_details;
        }
        this.isGeneratingELR = false;
        this.snackBar.open("eLR Generated Successfully", "Success", {
          duration: 3000,
        });
      },
      (error: any) => {
        console.error('LR generation failed', error);
        this.isGeneratingELR = false;
        this.snackBar.open("eLR Generation Failed", "Fail", {
          duration: 3000,
        });
      }
    );
  }
}
